import React, { useState } from 'react';

import { Row, Col } from 'antd';
import Axios from 'axios';
import { Formik, Field } from 'formik';

import styled from 'styled-components';

import { getMoment, toISODate } from '@libs/NwMoment';
import { validateDate } from '@libs/NwUtils';

import { forceReloadContact } from '@hooks/API/Contact/UseContact';
import useFormFieldFocus from '@hooks/Utils/UseFormFieldFocus';

import { NwCancelButton, NwSaveButton } from '@components/Gui/NwButton';
import NwDrawer from '@components/Gui/NwDrawer';
import { NWDatePicker } from '@components/Gui/NwForm/NwFormItems';
import { NwForm, NwFormButtonsBar } from '@components/Gui/NwForm/NwFormWrapper';

const FormItem = styled.div`
    .ant-form-item-control-input-content {
        width: 100%;
    }
`;

const InAgencySinceDrawer = ({ contact, onClose }) => {
    const [touchForm, setTouchForm] = useState(false);

    const inAgencySince =
        contact.NetworkAgencies && contact.NetworkAgencies[0] && contact.NetworkAgencies[0].InAgencyFrom
            ? contact.NetworkAgencies[0].InAgencyFrom
            : null;

    let initialValues = {
        inAgencySince: inAgencySince,
    };

    useFormFieldFocus('Name');

    const [isSubmitting, setIsSubmitting] = useState(false);

    const submitForm = async (values, setStatus, setSubmitting) => {
        setSubmitting(true);
        const networkAgency = contact.NetworkAgencies[0];
        try {
            await Axios.post('/models/setInAgencyFrom', {
                ContactID: contact.ID,
                NetworkAgencyID: networkAgency.NetworkAgencyID,
                InAgencyFrom: toISODate(values.inAgencySince),
            });
            forceReloadContact(contact.ID);
            onClose();
        } catch (error) {
            console.error('Update Network InAgencySince Error => ', error);
            setSubmitting(false);
        }
    };
    return (
        <NwDrawer touchForm={touchForm} onTouchForm={setTouchForm} title="Edit Model Details" onClose={onClose}>
            <Formik
                initialValues={initialValues}
                onSubmit={(values, { setStatus, setSubmitting }) => {
                    setStatus();
                    submitForm(values, setStatus, setSubmitting);
                }}
            >
                {({ isSubmitting, values, handleSubmit }) => (
                    <NwForm
                        values={values}
                        //onTouchForm={onTouchForm}
                        onFinish={handleSubmit}
                        layout="vertical"
                    >
                        <Row gutter={10}>
                            <Col lg={24} md={24} sm={24} xs={24}>
                                {/* BirthDate */}
                                <FormItem>
                                    <Field
                                        component={NWDatePicker}
                                        size="large"
                                        label="In the Agency since"
                                        name="inAgencySince"
                                        format="MMM DD, YYYY"
                                        //style={{ width: "100%" }}
                                        value={values.inAgencySince ? getMoment(values.inAgencySince) : null}
                                        validate={(value) => validateDate(value, true)}
                                    />
                                </FormItem>
                            </Col>
                        </Row>
                        <NwFormButtonsBar
                            marginTop="2rem"
                            left={
                                <NwCancelButton
                                    disabled={isSubmitting}
                                    onClick={() => {
                                        //onTouchForm(false);
                                        onClose();
                                    }}
                                />
                            }
                            right={<NwSaveButton htmlType="submit" loading={isSubmitting} />}
                        />
                    </NwForm>
                )}
            </Formik>
        </NwDrawer>
    );
};

export default InAgencySinceDrawer;
